import { createSelector } from 'reselect'
import { selectCustomersById } from './customers'

const byMessageId = state => state.ratings.byMessageId

export const selectRatingsByMessageId = createSelector(
  byMessageId,
  selectCustomersById,
  (byMessageId, customersById) => {
    const ratingsByMessageId = {}

    for (const messageId in byMessageId) {
      ratingsByMessageId[messageId] = Object.assign(
        {},
        byMessageId[messageId],
        {
          actor: customersById[byMessageId[messageId].actor.id],
        }
      )
    }

    return ratingsByMessageId
  }
)
